import React from "react";
import Styles from "./style.module.scss";
import Icon from "@Atom/Icon";
import { useNavigate } from "react-router-dom";

export default function JobSeekersShowcase() {
  const navigate = useNavigate();
  return (
    <div className={Styles.container}>
      <div className={Styles.wrapper}>
        <div>
          <span className={Styles.H1}>Dapatkan Pekerjaan Dengan Mudah</span>
          <span className={Styles.desc}>
            Dapatkan pekerjaan impianmu! Temukan berbagai lowongan pekerjaan
            terbaru dan lamar dengan mudah dalam satu platform.
          </span>

          <div className={Styles.benefitBox}>
            <div className={Styles.listBenefit}>
              <div className={Styles.iconStarCheck}>
                <Icon icon={"star-check"} size={24} color={"#FFF"} />
              </div>

              <span className={Styles.span}>
                {" "}
                Beragam jenis pekerjaan dan posisi
              </span>
            </div>
            <div className={Styles.listBenefit}>
              <div className={Styles.iconStarCheck}>
                <Icon icon={"star-check"} size={24} color={"#FFF"} />
              </div>

              <span className={Styles.span}>250+ partner perusahaan</span>
            </div>
            <div className={Styles.listBenefit}>
              <div className={Styles.iconStarCheck}>
                <Icon icon={"star-check"} size={24} color={"#FFF"} />
              </div>

              <span className={Styles.span}>Proses lamar cepat</span>
            </div>
          </div>

          <div className={Styles.buttonBox}>
            <div
              className={Styles.buttonPrimary}
              onClick={() => {
                navigate("/job-seeker");
              }}
            >
              Cari Lowongan Sekarang
              <Icon icon={"bag-profile"} color={"FFF"} size={24} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
